export default "__VITE_ASSET__rnxAA57Q__"